<template>
    <header class="public-header">
      <div class="container">
        <div class="logo">
  <a href="/">
    <img src="@/assets/logo_2025.png" alt="StreamboxTV" />
  </a>
</div>

  
        <nav :class="{ open: isMenuOpen }" class="nav">
            <router-link to="/" class="nav-link">Home</router-link>

            <router-link to="/about" class="nav-link">About StreamBox</router-link>
            <router-link to="/playlist" class="nav-link">Manage content</router-link>
            <router-link to="/reseller" class="nav-link">Operators</router-link>
           
            <router-link to="/contact" class="nav-link">Contact</router-link>
        </nav>
  
        <button class="menu-toggle" @click="isMenuOpen = !isMenuOpen">
          <span></span>
          <span></span>
          <span></span>
        </button>
      </div>
    </header>
  </template>
  
  <script>
  export default {
    name: "PublicHeader",
    data() {
      return {
        isMenuOpen: false,
      };
    },
    methods: {
  scrollToSection(id) {
    const section = document.getElementById(id);
    if (section) {
      section.scrollIntoView({ behavior: 'smooth' });
    }
  }
}
,
    watch: {
      $route() {
        this.isMenuOpen = false; // zatvori meni posle navigacije
      }
    }
  };
  </script>
  
  <style scoped>
  .public-header {
    background: rgb(18,20,24);
    color: white;
    padding: 10px 0;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
    position: sticky;
    top: 0;
    z-index: 1000;
  }
  
  .container {
    max-width: 1200px;
    margin: auto;
    padding: 10px 20px;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  
  .logo img {
    height: 30px;
  }
  
  .nav {
    display: flex;
    gap: 20px;
  }
  
  .nav-link {
    color: white;
    text-decoration: none;
    font-weight: bold;
    transition: color 0.3s;
  }
  
  .nav-link:hover {
    color: #3fb9ff;
  }
    .nav-link:active {
    color: #3fb9ff;
  }
 

  .menu-toggle {
    display: none;
    flex-direction: column;
    gap: 5px;
    background: black;
    border: none;
    cursor: pointer;
  }
  
  .menu-toggle span {
    width: 25px;
    height: 3px;
    background: white;
    display: block;
  }
  
  @media (max-width: 768px) {
    .nav {
      position: absolute;
      top: 60px;
      right: 0;
      background: #1e1e1e;
      flex-direction: column;
      width: 100%;
      text-align: right;
      padding: 10px 20px;
      display: none;
    }
  
    .nav.open {
      display: flex;
    }
  
    .menu-toggle {
      display: flex;
    }
  }
  </style>
  